import React from 'react'
import { getI18nText } from '../../services/i18nService'

const Navigation = ({ microcopy, data }) => {
  return (
    <ul className="product-details__inpagenav in-pagenav d-flex align-items-center no-bullets">
      <li>
        <a href="#overview">
          <span>{getI18nText(microcopy, 'product.overview')}</span>
        </a>
      </li>
      {data && (data.ResCadFileStep || data.ResCadenasCataloguePath) ? (
        <li>
          <a href="#cad">
            <span>{getI18nText(microcopy, 'product.cad')}</span>
          </a>
        </li>
      ) : null}
      <li>
        <a href="#tech">
          <span>{getI18nText(microcopy, 'product.technicaldetails')}</span>
        </a>
      </li>
      {data && data.pimData && data.pimData.ResSchematicJpg ? (
        <li>
          <a href="#schematics">
            <span>{getI18nText(microcopy, 'product.schematicanddimensions')}</span>
          </a>
        </li>
      ) : null}
      {/* <li>
        <a href="#accessories">
          <span>{getI18nText(microcopy, 'product.accessories')}</span>
        </a>
      </li> */}
    </ul>
  )
}

export default Navigation
